import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { AlertsScreen } from '@/features/alerts/AlertsScreen';
import { useTenant } from '@/lib/tenant';

function AlertsRoute() {
  const { slug } = Route.useParams();
  const { setSlug } = useTenant();
  useEffect(() => {
    setSlug(slug);
  }, [slug, setSlug]);
  return <AlertsScreen slug={slug} />;
}

export const Route = createFileRoute('/tenants/$slug/alerts')({
  component: AlertsRoute,
});
